import { SupplierCompanyMessage } from '../../../../types/SupplierCompanyMessage';
import { CompanyTabs } from '../../common/CompanyTabs';

import { SupplierCommunicationPreferencesTab } from './tabs/SupplierCommunicationPreferencesTab';
import { SupplierDetailsTab } from './tabs/SupplierDetailsTab';
import { SupplierSettingsTab } from './tabs/SupplierSettingsTab';

interface SupplierDetailsPageTabContentProps {
    tab: CompanyTabs;
    supplier: SupplierCompanyMessage;
    onEditSubmit: (data: SupplierCompanyMessage) => Promise<void>;
}

export const SupplierDetailsPageTabContent = ({ tab, supplier, onEditSubmit }: SupplierDetailsPageTabContentProps) => {
    switch (tab) {
        case CompanyTabs.DETAILS:
            return <SupplierDetailsTab supplier={supplier} onEditSubmit={onEditSubmit} />;
        case CompanyTabs.SETTINGS:
            return <SupplierSettingsTab supplier={supplier} />;
        case CompanyTabs.COMMUNICATION_PREFERENCES:
            return <SupplierCommunicationPreferencesTab companyId={supplier.id} />;
    }
};
